import { render, staticRenderFns } from "./LiveBro.vue?vue&type=template&id=be86a7e2&scoped=true"
import script from "./LiveBro.vue?vue&type=script&lang=js"
export * from "./LiveBro.vue?vue&type=script&lang=js"
import style0 from "./LiveBro.vue?vue&type=style&index=0&id=be86a7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be86a7e2",
  null
  
)

export default component.exports